<template>
    <div ref="battery_unknown"></div>
</template>

<script>
import BatteryUnknown from "!!raw-loader!../../assets/ricoh_assets/icons/ICN001-08_battery_unknown.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.battery_unknown.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = BatteryUnknown

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>

<style>
</style>